<template>
  <header v-if="!isAccess" class="primary">
    <v-toolbar fixed app class="elevation-0">
      <v-container fluid class="pa-0 ma-0">
        <v-layout>
          <v-layout id="breadContainer" class="elevation-0">
            <v-flex style="display: flex;" align-center>
              <slot name="breadcrumbs"></slot>
            </v-flex>
          </v-layout>
          <slot name="local-actions"></slot>
        </v-layout>
      </v-container>
    </v-toolbar>
  </header>
</template>

<script>
  export default {
    name: 'idonia-embed-header',
    props: {
      mini: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    computed: {
      isMagicLink () {
        if (this.$route.name) {
          return this.$route.name.startsWith('public-file')
        } else {
          return false
        }
      },
      isAccess () {
        return (this.$route.name || '').startsWith('magic-link') || (this.$route.path || '').includes('access')
      }
    }
  }
</script>
<style lang="scss" scoped>
  #breadContainer {
    overflow-x: auto;
    margin: 0 20px;
  }

  header {
    display: flex;
  }

  .toolbar__title /deep/ {
    margin-right: 20px;
  }

  button[disabled].btn.btn--disabled, a[disabled].btn.btn--disabled {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-bottom: 5px rgba(255, 255, 255, 0.7) solid;
  }

  .platform-actions .menu {
    max-height: 36px;
  }

  .small-logo {
    max-height: 64px;
  }

  .logo {
    height: 128px;
    min-width: 300px;
    max-width: 300px;
    display: flex;
    align-content: center;
    justify-content: center;
    img {
      max-height: 118px;
      max-width: 270px;
      margin: auto;
    }
  }

  .logo.mini {
    height: 64px;
    min-width: initial;
    max-width: 300px;
    align-content: left;
    justify-content: left;
    img {
      margin-left:24px;
      max-height: 60px;
    }
  }

  .mobile-title {
    display: flex;
    align-content: center;
  }

  nav.extension {
    background-color: #E0E0E0 !important;
  }
  #HsearchList{
    margin-top: 4px;
  }
  #logoContainer{
    position: fixed;
    margin-left: 0px;
    z-index: 5;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/IdoniaEmbedHeader.vue